import React from 'react';
import { string } from 'prop-types';
import { Alert, Button } from '@thd-olt-component-react/core-ui';
import { useDrawer } from '@thd-olt-component-react/drawer';
import { Footer } from '../shared/Footer';

import * as styles from '../shared/messages.module.scss';
import * as drawerStyles from '../shared/drawers.module.scss';
import { GENERIC_ERROR } from '../shared/Constants';

export const ErrorDrawer = ({ message }) => {
  const { closeDrawer } = useDrawer();

  return (
    <div className={drawerStyles.container}>
      <div className={drawerStyles.content}>
        <div className={styles.content}>
          <Alert title="Error" type="danger" inline />
          <p className={styles.messageText}>{message || GENERIC_ERROR}</p>
        </div>
      </div>
      <Footer>
        <Button className={styles.button} onClick={closeDrawer}>OK</Button>
      </Footer>
    </div>
  );
};

ErrorDrawer.propTypes = {
  message: string
};

ErrorDrawer.defaultProps = {
  message: null
};